import type { PropsWithChildren } from 'react'
import { motion } from 'motion/react'
import { pageEnterContainer } from '@/lib/motion'

type PageEnterProps = PropsWithChildren<{
  /**
   * When true, children are expected to be motion sections using
   * `pageEnterSection` variants (dashboard header → metrics → tabs).
   */
  staggerSections?: boolean
}>

/**
 * In-page stagger only (dashboard). Route-level enter is handled once by
 * `page-route-enter` on the router outlet — no slide or second fade here.
 */
export function PageEnter({
  children,
  staggerSections = false,
}: PageEnterProps) {
  if (!staggerSections) {
    return <>{children}</>
  }

  return (
    <motion.div
      className="min-h-0 w-full"
      variants={pageEnterContainer}
      initial="hidden"
      animate="visible"
    >
      {children}
    </motion.div>
  )
}

/** Re-export for pages that define their own staggered sections. */
export { pageEnterSection } from '@/lib/motion'
